export default __webpack_public_path__ + "static/932-d77d5172dea7256275b00efad50d6e2e.gif";